export const EVENT_WORKSPACE_QUEUE_IDS = [
    'today',
    'thisWeek',
    'inProgress',
    'past',
    'all',
    'needsApproval',
    'underReview',
];
//# sourceMappingURL=event-workspace-queue-ids.js.map